import originalToTranslit from 'cyrillic-to-translit-js';

const toTranslit = (value: string, spaceReplacement = '-') => {
	let slug = value
		.replace(/[^а-яА-ЯЁёa-zA-Z0-9\s]/gi, '')
		.replace(/  +/g, ' ')
		.trim();

	slug = originalToTranslit()
		.transform(slug, spaceReplacement)
		.replace(/[^a-z0-9-]/gi, '');

	while (slug.startsWith(spaceReplacement)) {
		slug = slug.slice(1);
	}
	while (slug.endsWith(spaceReplacement)) {
		slug = slug.slice(0, -1);
	}
	return slug;
};

export default toTranslit;



// WEBPACK FOOTER //
// src/util/cyrillic-to-translit.js